import React, { useCallback, useRef, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import InputValidationTooltip from "../../common/InputValidationTooltip";
import { alphaWithSpacesRegex } from "constants/validations";

interface CityFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    id?: string;
    className?: string;
}

const CityField = ({ register, error, id, className = "" }: CityFieldProps) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const tooltipTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            const validValue = value.replace(alphaWithSpacesRegex, "");

            if (value !== validValue && value.length > 0) {
                inputRef.current = e.target;
                setShowTooltip(true);

                if (tooltipTimeoutRef.current) clearTimeout(tooltipTimeoutRef.current);

                tooltipTimeoutRef.current = setTimeout(() => {
                    setShowTooltip(false);
                }, 2000);
            }

            if (validValue.length <= 20) {
                e.target.value = validValue;
                if (register.onChange) {
                    register.onChange(e);
                }
            }
        },
        [register]
    );

    return (
        <div className="form-control">
            <label className="label h-7" htmlFor={id}>
                <span className="text-base-content">City</span>
            </label>
            <input
                {...register}
                onChange={handleChange}
                ref={(e) => {
                    if (register.ref) {
                        register.ref(e);
                    }
                    inputRef.current = e;
                }}
                id={id}
                type="text"
                placeholder="Mayberry"
                className={`input input-bordered bg-base-100 h-9 text-sm ${error ? "input-error" : ""} ${className}`}
                maxLength={20}
            />
            <InputValidationTooltip message="Only letters allowed" show={showTooltip} targetRef={inputRef} />
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default CityField;
